import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './loading-dots.module.scss';

/**
 * LoadingDots component - Shows animated loading dots with the exact same behavior as the original implementation
 */
export const LoadingDots = () => {
  const { t } = useTranslation();
  const [dotsCounter, setDotsCounter] = useState(3);
  
  // Animation effect for the dots - exact same implementation as the original
  useEffect(() => {
    if (dotsCounter > 0) {
      const timeout = setTimeout(() => {
        setDotsCounter(dotsCounter - 1);
      }, 1000);
      
      return () => clearTimeout(timeout);
    } else {
      setDotsCounter(3);
    }
  }, [dotsCounter]);
  
  return (
    <p className='color-grey-300 font-flexo-light'>
      {t('templates.splash.logout')}{Array.from(Array(3)).map((_dot, dot_i) => (
        <span key={dot_i}>
          {(dot_i + 1) <= dotsCounter ? <>.</> : <span style={{color: 'transparent', margin: 0, padding: 0}}>|</span>}
        </span>
      ))}
    </p>
  );
};

export default LoadingDots; 